import { render, staticRenderFns } from "./AlertasDropdown.vue?vue&type=template&id=0118b014&scoped=true&"
import script from "./AlertasDropdown.vue?vue&type=script&lang=js&"
export * from "./AlertasDropdown.vue?vue&type=script&lang=js&"
import style0 from "./AlertasDropdown.vue?vue&type=style&index=0&id=0118b014&prod&scoped=true&lang=css&"
import style1 from "./AlertasDropdown.vue?vue&type=style&index=1&id=0118b014&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0118b014",
  null
  
)

export default component.exports